"use client";

import { c as _c } from "react/compiler-runtime";
import type { FUSportsLivescoreEvent, SearchEntityResult } from "fansunited-data-layer";
import { cn } from "@/utilities/core/cn";
import { TeamLogo } from "@/components/ui/TeamLogo";
import { MatchTimeColumn } from "./MatchTimeColumn";
import { asCompetitor, getResultScore } from "@/views/livescore/utils/livescore";
interface FootballMatchRowProps {
  event: FUSportsLivescoreEvent;
  entities: Record<string, SearchEntityResult>;
}
export function FootballMatchRow(t0) {
  const $ = _c(96);
  const {
    event,
    entities
  } = t0;
  const isLive = event.status?.type === "LIVE";
  const isFinished = event.status?.type === "FINISHED";
  const isActive = isLive || isFinished;
  let t1;
  if ($[0] !== event.score) {
    t1 = getResultScore(event.score);
    $[0] = event.score;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const totalScore = t1;
  let t2;
  if ($[2] !== entities || $[3] !== event.competitorOne.id) {
    t2 = asCompetitor(entities, event.competitorOne.id);
    $[2] = entities;
    $[3] = event.competitorOne.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const teamOne = t2;
  let t3;
  if ($[5] !== entities || $[6] !== event.competitorTwo.id) {
    t3 = asCompetitor(entities, event.competitorTwo.id);
    $[5] = entities;
    $[6] = event.competitorTwo.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const teamTwo = t3;
  const nameOne = teamOne?.name ?? event.competitorOne.id;
  const nameTwo = teamTwo?.name ?? event.competitorTwo.id;
  const numC1 = Number(totalScore.competitorOne);
  const numC2 = Number(totalScore.competitorTwo);
  const c1Won = isFinished && !isNaN(numC1) && !isNaN(numC2) && numC1 > numC2;
  const c2Won = isFinished && !isNaN(numC1) && !isNaN(numC2) && numC2 > numC1;
  const scoreStr = isActive ? `${totalScore.competitorOne ?? "-"} : ${totalScore.competitorTwo ?? "-"}` : "-";
  const t4 = isLive ? "text-green-500" : isActive ? "text-foreground" : "text-muted-foreground";
  let t5;
  if ($[8] !== t4) {
    t5 = cn("text-sm font-bold tabular-nums", t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const scoreClass = t5;
  const t6 = isLive ? "text-green-500" : "text-foreground";
  let t7;
  if ($[10] !== t6) {
    t7 = cn("w-8 text-center text-sm font-bold tabular-nums shrink-0", t6);
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const teamScoreClass = t7;
  let t8;
  if ($[12] !== event) {
    t8 = <div className="w-16 shrink-0 flex items-center justify-center py-3.5 mr-1"><MatchTimeColumn event={event} sport="football" /></div>;
    $[12] = event;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = teamOne?.assets?.logo;
  const t10 = teamOne?.country?.code;
  const t11 = teamOne?.country?.flag;
  const t12 = teamOne?.metadata?.branding?.primaryColor;
  const t13 = teamOne?.metadata?.branding?.secondaryColor;
  let t14;
  if ($[14] !== nameOne || $[15] !== t10 || $[16] !== t11 || $[17] !== t12 || $[18] !== t13 || $[19] !== t9) {
    t14 = <TeamLogo src={t9} alt={nameOne} size="sm" countryCode={t10} countryFlag={t11} primaryColor={t12} secondaryColor={t13} />;
    $[14] = nameOne;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = c1Won ? "font-semibold" : c2Won ? "text-muted-foreground" : "font-medium";
  let t16;
  if ($[21] !== t15) {
    t16 = cn("flex-1 text-sm truncate", t15);
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== nameOne || $[24] !== t16) {
    t17 = <span className={t16}>{nameOne}</span>;
    $[23] = nameOne;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const t18 = isActive ? teamScoreClass : "w-8 text-center text-sm text-muted-foreground shrink-0";
  const t19 = isActive ? totalScore.competitorOne ?? "-" : "-";
  let t20;
  if ($[26] !== t18 || $[27] !== t19) {
    t20 = <div className={t18}>{t19}</div>;
    $[26] = t18;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t14 || $[30] !== t17 || $[31] !== t20) {
    t21 = <div className="flex items-center gap-2 pr-1">{t14}{t17}{t20}</div>;
    $[29] = t14;
    $[30] = t17;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  const t22 = teamTwo?.assets?.logo;
  const t23 = teamTwo?.country?.code;
  const t24 = teamTwo?.country?.flag;
  const t25 = teamTwo?.metadata?.branding?.primaryColor;
  const t26 = teamTwo?.metadata?.branding?.secondaryColor;
  let t27;
  if ($[33] !== nameTwo || $[34] !== t22 || $[35] !== t23 || $[36] !== t24 || $[37] !== t25 || $[38] !== t26) {
    t27 = <TeamLogo src={t22} alt={nameTwo} size="sm" countryCode={t23} countryFlag={t24} primaryColor={t25} secondaryColor={t26} />;
    $[33] = nameTwo;
    $[34] = t22;
    $[35] = t23;
    $[36] = t24;
    $[37] = t25;
    $[38] = t26;
    $[39] = t27;
  } else {
    t27 = $[39];
  }
  const t28 = c2Won ? "font-semibold" : c1Won ? "text-muted-foreground" : "font-medium";
  let t29;
  if ($[40] !== t28) {
    t29 = cn("flex-1 text-sm truncate", t28);
    $[40] = t28;
    $[41] = t29;
  } else {
    t29 = $[41];
  }
  let t30;
  if ($[42] !== nameTwo || $[43] !== t29) {
    t30 = <span className={t29}>{nameTwo}</span>;
    $[42] = nameTwo;
    $[43] = t29;
    $[44] = t30;
  } else {
    t30 = $[44];
  }
  const t31 = isActive ? teamScoreClass : "w-8 text-center text-sm text-muted-foreground shrink-0";
  const t32 = isActive ? totalScore.competitorTwo ?? "-" : "-";
  let t33;
  if ($[45] !== t31 || $[46] !== t32) {
    t33 = <div className={t31}>{t32}</div>;
    $[45] = t31;
    $[46] = t32;
    $[47] = t33;
  } else {
    t33 = $[47];
  }
  let t34;
  if ($[48] !== t27 || $[49] !== t30 || $[50] !== t33) {
    t34 = <div className="flex items-center gap-2 mt-0.5 pr-1">{t27}{t30}{t33}</div>;
    $[48] = t27;
    $[49] = t30;
    $[50] = t33;
    $[51] = t34;
  } else {
    t34 = $[51];
  }
  let t35;
  if ($[52] !== t21 || $[53] !== t34) {
    t35 = <div className="flex-1 md:hidden py-3 min-w-0 space-y-2">{t21}{t34}</div>;
    $[52] = t21;
    $[53] = t34;
    $[54] = t35;
  } else {
    t35 = $[54];
  }
  const t36 = c1Won ? "font-semibold" : c2Won ? "text-muted-foreground" : "font-medium";
  let t37;
  if ($[55] !== t36) {
    t37 = cn("text-sm truncate", t36);
    $[55] = t36;
    $[56] = t37;
  } else {
    t37 = $[56];
  }
  let t38;
  if ($[57] !== nameOne || $[58] !== t37) {
    t38 = <span className={t37}>{nameOne}</span>;
    $[57] = nameOne;
    $[58] = t37;
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  const t39 = teamOne?.assets?.logo;
  const t40 = teamOne?.country?.code;
  const t41 = teamOne?.country?.flag;
  const t42 = teamOne?.metadata?.branding?.primaryColor;
  const t43 = teamOne?.metadata?.branding?.secondaryColor;
  let t44;
  if ($[60] !== nameOne || $[61] !== t39 || $[62] !== t40 || $[63] !== t41 || $[64] !== t42 || $[65] !== t43) {
    t44 = <TeamLogo src={t39} alt={nameOne} size="md" countryCode={t40} countryFlag={t41} primaryColor={t42} secondaryColor={t43} />;
    $[60] = nameOne;
    $[61] = t39;
    $[62] = t40;
    $[63] = t41;
    $[64] = t42;
    $[65] = t43;
    $[66] = t44;
  } else {
    t44 = $[66];
  }
  let t45;
  if ($[67] !== t38 || $[68] !== t44) {
    t45 = <div className="flex-1 flex items-center gap-2 justify-end min-w-0">{t38}{t44}</div>;
    $[67] = t38;
    $[68] = t44;
    $[69] = t45;
  } else {
    t45 = $[69];
  }
  let t46;
  if ($[70] !== scoreClass || $[71] !== scoreStr) {
    t46 = <div className="w-20 shrink-0 text-center"><span className={scoreClass}>{scoreStr}</span></div>;
    $[70] = scoreClass;
    $[71] = scoreStr;
    $[72] = t46;
  } else {
    t46 = $[72];
  }
  const t47 = teamTwo?.assets?.logo;
  const t48 = teamTwo?.country?.code;
  const t49 = teamTwo?.country?.flag;
  const t50 = teamTwo?.metadata?.branding?.primaryColor;
  const t51 = teamTwo?.metadata?.branding?.secondaryColor;
  let t52;
  if ($[73] !== nameTwo || $[74] !== t47 || $[75] !== t48 || $[76] !== t49 || $[77] !== t50 || $[78] !== t51) {
    t52 = <TeamLogo src={t47} alt={nameTwo} size="md" countryCode={t48} countryFlag={t49} primaryColor={t50} secondaryColor={t51} />;
    $[73] = nameTwo;
    $[74] = t47;
    $[75] = t48;
    $[76] = t49;
    $[77] = t50;
    $[78] = t51;
    $[79] = t52;
  } else {
    t52 = $[79];
  }
  const t53 = c2Won ? "font-semibold" : c1Won ? "text-muted-foreground" : "font-medium";
  let t54;
  if ($[80] !== t53) {
    t54 = cn("text-sm truncate", t53);
    $[80] = t53;
    $[81] = t54;
  } else {
    t54 = $[81];
  }
  let t55;
  if ($[82] !== nameTwo || $[83] !== t54) {
    t55 = <span className={t54}>{nameTwo}</span>;
    $[82] = nameTwo;
    $[83] = t54;
    $[84] = t55;
  } else {
    t55 = $[84];
  }
  let t56;
  if ($[85] !== t52 || $[86] !== t55) {
    t56 = <div className="flex-1 flex items-center gap-2 min-w-0">{t52}{t55}</div>;
    $[85] = t52;
    $[86] = t55;
    $[87] = t56;
  } else {
    t56 = $[87];
  }
  let t57;
  if ($[88] !== t45 || $[89] !== t46 || $[90] !== t56) {
    t57 = <div className="hidden md:flex flex-1 items-center gap-2 min-w-0">{t45}{t46}{t56}</div>;
    $[88] = t45;
    $[89] = t46;
    $[90] = t56;
    $[91] = t57;
  } else {
    t57 = $[91];
  }
  let t58;
  if ($[92] !== t35 || $[93] !== t57 || $[94] !== t8) {
    t58 = <div className="flex items-stretch">{t8}{t35}{t57}</div>;
    $[92] = t35;
    $[93] = t57;
    $[94] = t8;
    $[95] = t58;
  } else {
    t58 = $[95];
  }
  return t58;
}